import styled from 'styled-components';
import { colors, typography } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';

export const LinkWrapper = styled.li`
    list-style: none;

    a {
        display: flex;
        cursor: pointer;
        padding: ${token('space.050', '4px')};

        &:hover,
        &:active,
        &:focus {
            text-decoration: none;
            background-color: ${token('color.background.neutral.subtle.hovered', colors.N10)};
        }
    }
`;

export const ContentWrapper = styled.div`
    flex: 1;
    ${mixins.multiLineClamp(4)};
    word-break: break-word;
    & h3 {
        ${typography.h400};
    }

    & p {
        margin-top: ${token('space.050', '4px')};
        color: ${token('color.text.subtlest', colors.N400)};
    }
`;

export const iconDimension = grid.multiple(3).px;

export const IconWrapper = styled.div`
    margin-right: ${token('space.200', '16px')};
    margin-top: ${token('space.050', '4px')};
    min-width: ${iconDimension};
    color: ${token('color.icon', colors.N800)};

    & img {
        height: ${iconDimension};
        object-fit: contain;
    }
`;
